import React from 'react';
import styled from 'styled-components';
import Breadcrumb from '@catalogo/theme-breadcrumb';

export const BreadCrumb = props => (
  <BreacrumbContainer>
    <Breadcrumb {...props} />
  </BreacrumbContainer>
);

export default BreadCrumb;

const BreacrumbContainer = styled.div`
  margin-top: 20px;
`;
